import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';

export default function AdminLogin() {
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  // 「戻り先」(ない場合はデフォルトページ)
  const from = location.state?.from?.pathname || '/admin/tomoya';

  const handleSubmit = async e => {
    e.preventDefault();
    const success = await login('admin', pass);
    if (success) {
      // 元ページへリダイレクト
      navigate(from, { replace: true });
    } else {
      setError('認証に失敗しました。パスワードを確認してください。');
    }
  };

  return (
    <div id="login">
      <h2>親用ログイン</h2>
      <form onSubmit={handleSubmit}>
        <div className="user">
          <label>ユーザ名</label>
          <span>admin</span>
        </div>
        <div className="pass">
          <label>パスワード</label>
          <input
            type="password"
            value={pass}
            onChange={e => setPass(e.target.value)}
            required
          />
        </div>
        <div className="buttons">
          <button type="submit">ログイン</button>
        </div>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
}
